var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('va-list',{attrs:{"filters":_vm.filters,"include":[
      'main_crop_entity',
      'land_ownership_entity',
      'cover_crop_used_entity',
      'tillage_entity',
    ],"sort-by":['land_ownership_entity.ownership', 'crop_area_ac'],"sort-desc":[true, true]}},[_c('va-data-table',{attrs:{"fields":_vm.fields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }